export class ErrorModel {
  set original(original) {
    this.original = original
  }

  get original() {
    return this.original
  }

  constructor(status, code, message, redirect) {
    this.status = status
    this.code = code
    this.message = message
    this.redirect = redirect
  }
}
